import { render, staticRenderFns } from "./AppsList.vue?vue&type=template&id=8e122d1c&scoped=true"
import script from "./AppsList.vue?vue&type=script&lang=js"
export * from "./AppsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e122d1c",
  null
  
)

export default component.exports